import { dateColDefs } from '@/constants/ag-grid-scenario-builder.constant'
import { optimizationDefaultColDefs } from '@/constants/portfolioOptimization.constant'
import { ColDef } from '@ag-grid-community/core'

export const TransactionReportColumns = [
  {
    ...optimizationDefaultColDefs,
    headerName: 'Buy/Sell',
    field: 'actn',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Par',
    field: 'par',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Sec ID',
    field: 'security_id',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Description',
    field: 'description',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Coupon',
    field: 'coupon',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...{ ...optimizationDefaultColDefs, ...dateColDefs },
    headerName: 'Maturity',
    field: 'maturity_date',
    filter: 'agDateColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Sector',
    field: 'sector',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: "Moody's",
    field: 'moody',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Price',
    field: 'price',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'S&P Quality',
    field: 'sandp',
    cellDataType: 'text',
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Accrued Income',
    field: 'accrue',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
    hide: true,
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Cash Flow Yield',
    field: 'cf_yld',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
    hide: true,
  },
  {
    ...optimizationDefaultColDefs,
    field: 'edur',
    headerName: 'Effective Duration - Level',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
    hide: true,
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Effective D2 - Slope',
    field: 'ed2',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
    hide: true,
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Effective D3 - Curvature',
    field: 'ed3',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
    hide: true,
  },
  {
    ...optimizationDefaultColDefs,
    headerName: 'Convexity',
    field: 'convex',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
    hide: true,
  },
  {
    ...optimizationDefaultColDefs,
    field: 'end_par',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
    hide: true,
  },
  {
    ...optimizationDefaultColDefs,
    field: 'pct_mkt',
    cellDataType: 'number',
    filter: 'agNumberColumnFilter',
    hide: true,
  },
] as ColDef[]
